import React from 'react';
import { View, Linking, Alert, Platform, ScrollView } from 'react-native';
import axios from 'axios';
import { router } from 'expo-router';
import * as Clipboard from 'expo-clipboard';
import { Text, TouchableRipple, Button, Portal, Modal, TextInput } from 'react-native-paper';
import { MoreCircle, TickCircle, Camera, More, Edit, CloseCircle, TickSquare } from 'iconsax-react-native';
import RBSheet from "react-native-raw-bottom-sheet";
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { MainContext } from '../../../contexts/MainContext';

export default function AdsCard({ data, isMy = false, isTransfered = false, needUpdate = false, reload }){
  const myContext = React.useContext(MainContext);
  const refRBSheet = React.useRef();
  const insets = useSafeAreaInsets();
  const [copyLoading, setCopyLoading] = React.useState(false);
  const [updateLoading, setUpdateLoading] = React.useState(false);
  const [archiveLoading, setArchiveLoading] = React.useState(false);
  const [archivingModalVisible, setArchivingModalVisible] = React.useState(false);
  const [archivingText, setArchivingText] = React.useState('');

  const handlePresentModalPress = React.useCallback(() => {
    refRBSheet.current.open();
  }, []);

  const displayAdsButton = React.useCallback(async () => {
    const supported = await Linking.canOpenURL(`https://40lsoton.ir/ad/${data.id}`);

    if (supported) {
      await Linking.openURL(`https://40lsoton.ir/ad/${data.id}`);
    } else {
      Alert.alert(`Don't know how to open this URL`);
    }
  }, [data.id]);

  const callButton = React.useCallback(async () => {
    await Linking.openURL(`tel:${data.phone}`);
  }, [data.phone]);

  const copyThemplateToClipboard = async () => {
    setCopyLoading(true);
    await axios.get(`/panel/ads/themplate/${data._id}`)
      .then(async (response) => {
        reload(true);
        refRBSheet.current?.close();
        if(response.data.status) {
          if(response.data.data) {
            await Clipboard.setStringAsync(response.data.data);
            myContext.activateSnackbar(true, 'کپی قالب با موفقیت انجام شد'); 
          } else {
            myContext.activateSnackbar(true, 'مشکل در تولید متن قالب');
          }
        } else {
          myContext.activateSnackbar(true, 'آگهی مورد نظر تایید نشده هست'); 
        }
      })
      .catch(myContext.handleAxiosError)
      .finally(() => setCopyLoading(false));
  };

  const updateAd = () => {
    setUpdateLoading(true);
    axios.get(`/panel/ads/update/${data._id}`)
      .then((response) => {
        reload(true);
        refRBSheet.current?.close();
        if(response.data.status) {         
          myContext.activateSnackbar(true, response.data.message);
        } else {
          myContext.activateSnackbar(true, response.data.message); 
        }
      })
      .catch(myContext.handleAxiosError)
      .finally(() => setUpdateLoading(false));
  }

  const archiveAd =() => {
    if(archivingText.length > 5) {
      setArchiveLoading(true);
      axios.post(`/panel/ads/archive/${data._id}`, {text: archivingText})
      .then((response) => {
        setArchivingModalVisible(false);
        reload(true);
        if(response.data.status) {         
          myContext.activateSnackbar(true, response.data.message);
        } else {
          myContext.activateSnackbar(true, response.data.message); 
        }
      })
      .catch(myContext.handleAxiosError)
      .finally(() => setArchiveLoading(false));
    } else {
      myContext.activateSnackbar(true, 'لطفا علت رد را بصورت کامل وارد کنید.');
    }
  }

  const deArchiveAd =() => {
    setArchiveLoading(true);
    axios.get(`/panel/ads/dis-archive/${data._id}`)
    .then((response) => {
      refRBSheet.current?.close();
      reload(true);
      if(response.data.status) {         
        myContext.activateSnackbar(true, response.data.message);
      } else {
        myContext.activateSnackbar(true, response.data.message); 
      }
    })
    .catch(myContext.handleAxiosError)
    .finally(() => setArchiveLoading(false));
  }

  const confirmTransfer = () => {
    axios.get(`/panel/ads/confirm-transfer/${data._id}`)
    .then((response) => {
      reload(true);
      if(response.data) {         
        myContext.activateSnackbar(true, 'آگهی ارجاع داده شده با موفقیت تایید شد');
      } else {
        myContext.activateSnackbar(true, 'مشکل در تایید آگهی ارجاع داده شده'); 
      }
    })
    .catch(myContext.handleAxiosError)
    .finally(() => {});
  }

  const confirmAd = () => {
    axios.get(`/panel/ads/confirm-adds/${data._id}`)
    .then((response) => {
      reload(true);
      if(response.data) {         
        myContext.activateSnackbar(true, 'آگهی با موفقیت تایید شد');
      } else {
        myContext.activateSnackbar(true, 'مشکل در تایید آگهی'); 
      }
    })
    .catch(myContext.handleAxiosError)
    .finally(() => {});
  }

  const rejectAd = () => {
    axios.get(`/panel/ads/reject-adds/${data._id}`)
    .then((response) => {
      reload(true);
      if(response.data) {         
        myContext.activateSnackbar(true, 'آگهی با موفقیت رد شد');
      } else {
        myContext.activateSnackbar(true, 'مشکل در رد آگهی'); 
      }
    })
    .catch(myContext.handleAxiosError)
    .finally(() => {});
  }

  return (
    <>
      <View style={{ flex: 1, backgroundColor: '#fff', elevation: 2, borderRadius: 8, padding: 12, marginBottom: 8 }}>
        <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
          {
            data.class === 'confirm-add' ?
              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <TickCircle size="24" color="#3C9A4F" variant="Bold"/>
                <Text dir="rtl" style={{ fontSize: 12, marginStart: 8, color: '#3C9A4F' }}>تایید شده</Text>
              </View>
            :
              data.class === 'waiting-confirm' ?
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                  <MoreCircle size="24" color="#FFA200" variant="Bold"/>
                  <Text dir="rtl" style={{ fontSize: 12, marginStart: 8, color: '#FFA200' }}>در انتظار بررسی!</Text>
                </View>
              :
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                  <CloseCircle size="24" color="#D61600" variant="Bold"/>
                  <Text dir="rtl" style={{ fontSize: 12, marginStart: 8, color: '#D61600' }}>رد شده</Text>
                  {data.reject !== '' && <Text dir="rtl" style={{ marginStart: 4, fontSize: 10, color: '#8D8F94', direction: 'rtl' }}>({data.reject})</Text>}
                </View>
          }
          {(isMy || needUpdate) && <TouchableRipple borderless onPress={handlePresentModalPress} style={{ width: 30, height: 30, alignItems: 'center', justifyContent: 'center', borderRadius: 30, marginRight: -5 }}><More size="20" style={{ transform: [{rotate: '45deg'}, {rotateZ: '0.785398rad'}] }} color="#5B5E63" variant="Outline"/></TouchableRipple>}
        </View>
        <Text style={{ fontSize: 14, color: '#292D32', fontFamily: 'IRANSans_Medium', marginBottom: data.archiving_reason != '' ? 2 : 10, direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>{data.name}</Text>
        {data.archiving_reason != '' && <Text style={{ marginBottom: 10, fontSize: 10, color: '#8D8F94', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>علت بایگانی: {data.archiving_reason}</Text>}
        <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>  
          <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            <Text dir="rtl" style={{ fontSize: 14, color: '#6C6B6A', marginEnd: 8, direction: 'rtl' }}>کد آگهی:</Text>
            <View style={{ width: 60, borderWidth: 1, borderColor: '#292D32', borderRadius: 6, justifyContent: 'center', alignItems: 'center' }}><Text style={{ fontFamily: 'IRANSans_Bold', fontSize: 14 }}>{data.id}</Text></View>
          </View>   
          <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            <Camera size="24" color="#6C6B6A" variant="Outline"/>
            <Text dir="rtl" style={{ fontFamily: 'IRANSans_Bold' , fontSize: 14, color: '#292D32', marginStart: 8 }}>{data.imageCount}</Text>
          </View> 
        </View>
        <View style={{ borderTopWidth: 1, borderTopColor: '#EBEBEB', marginTop: 8, paddingTop: 8, flexDirection: 'row', flexWrap: 'wrap' }}>
          <View style={{ width: '50%', marginBottom: 8 }}>
            <Text dir="rtl" style={{ fontSize: 12, color: '#8D8F94', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>قیمت کل:</Text>
            <Text dir="rtl" style={{ fontSize: 13, color: '#5B5E63', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>{data.normalPrice}</Text>
          </View>
          <View style={{ width: '50%', marginBottom: 8 }}>
            <Text dir="rtl" style={{ fontSize: 12, color: '#8D8F94', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>ثبت کننده:</Text>
            <Text dir="rtl" style={{ fontSize: 13, color: '#5B5E63', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>{data.user}</Text>
          </View>
          {
            (isMy || needUpdate) &&
              <>
                <View style={{ width: '50%', marginBottom: 8 }}>
                  <Text dir="rtl" style={{ fontSize: 12, color: '#8D8F94', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>نام مالک:</Text>
                  <Text dir="rtl" style={{ fontSize: 13, color: '#5B5E63', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>{data.malekName}</Text>
                </View>
                <View style={{ width: '50%', marginBottom: 8 }}>
                  <Text dir="rtl" style={{ fontSize: 12, color: '#8D8F94', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>شماره مالک:</Text>
                  <Text dir="rtl" style={{ fontSize: 13, color: '#5B5E63', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>{data.phone}</Text>
                </View>
              </>
          }
          <View style={{ width: '50%', marginBottom: 8 }}>
            <Text dir="rtl" style={{ fontSize: 12, color: '#8D8F94', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>طبقه:</Text>
            <Text dir="rtl" style={{ fontSize: 13, color: '#5B5E63', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>{Array.isArray(data.floor) ? data.floor.join(', ') : data.floor}</Text>
          </View>
          <View style={{ width: '50%', marginBottom: 8 }}>
            <Text dir="rtl" style={{ fontSize: 12, color: '#8D8F94', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>سال ساخت:</Text>
            <Text dir="rtl" style={{ fontSize: 13, color: '#5B5E63', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>{data.direction_building}</Text>
          </View>
          <View style={{ width: '50%' }}>
            <Text dir="rtl" style={{ fontSize: 12, color: '#8D8F94', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>تاریخ ثبت:</Text>
            <Text dir="rtl" style={{ fontSize: 13, color: '#5B5E63', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>{data.created_at}</Text>
          </View>
          <View style={{ width: '50%' }}>
            <Text dir="rtl" style={{ fontSize: 12, color: '#8D8F94', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>تاریخ بروزرسانی:</Text>
            <Text dir="rtl" style={{ fontSize: 13, color: '#5B5E63', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>{data.updated_at}</Text>
          </View>
        </View>
        {
          (isMy || needUpdate) &&
            <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 8, paddingTop: 8, borderTopWidth: 1, borderTopColor: '#EBEBEB' }}>
              <Text dir="rtl" style={{ fontSize: 12, color: '#8D8F94', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>آدرس: </Text>
              <Text dir="rtl" style={{ fontSize: 13, color: '#5B5E63', fontFamily: 'IRANSans_Medium', flex: 1, flexWrap: 'wrap', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>{data.address}</Text>
            </View>
        }
        <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 16 }}>
          <Button labelStyle={{ fontSize: 16, fontFamily: 'IRANSans_Medium' }} style={{ width: (isMy || isTransfered || needUpdate) ? '83%' : '100%', borderRadius: 48, backgroundColor: '#2B93F3' }}  mode="contained" onPress={displayAdsButton}>نمایش</Button>
          {
            isTransfered ?
              <TouchableRipple borderless onPress={confirmTransfer} style={{ width: 48, height: 48, alignItems: 'center', justifyContent: 'center', borderRadius: 30 }}><TickSquare size="28" color="#292D32" variant="Outline"/></TouchableRipple>
            :
              (isMy || needUpdate) && <TouchableRipple borderless onPress={() => router.push(`adds/${data._id}`)} style={{ width: 48, height: 48, alignItems: 'center', justifyContent: 'center', borderRadius: 30 }}><Edit size="28" color="#292D32" variant="Outline"/></TouchableRipple>
          }
        </View>
      </View>
      <RBSheet
        ref={refRBSheet}
        closeOnDragDown={true}
        closeOnPressMask={true}
        height={310}
        customStyles={{
          container: {
            paddingBottom: insets.bottom
          },
          wrapper: {
            backgroundColor: "rgba(0, 0, 0, 0.3)"
          },
          draggableIcon: {
            backgroundColor: "#555"
          }
        }}
      >
        <ScrollView contentContainerStyle={{ paddingHorizontal: 20, paddingVertical: 8 }}>
          <Text style={{ fontSize: 14, color: '#292D32', fontFamily: 'IRANSans_Medium', marginBottom: 10, textAlign: 'center' }}>{data.name}</Text>
          {
            needUpdate ?
              <>
                <TouchableRipple rippleColor="rgba(0, 0, 0, .04)" onPress={callButton} style={{ width: '100%', height: 48, paddingHorizontal: 12, justifyContent: 'center', borderBottomColor: '#BFC0C5', borderBottomWidth: 1 }}>
                  <Text style={{ fontSize: 14, color: '#292D32', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>تماس با مالک</Text>
                </TouchableRipple>
                <TouchableRipple rippleColor="rgba(0, 0, 0, .04)" onPress={() => {refRBSheet.current?.close(); setArchivingModalVisible(true);}} style={{ width: '100%', height: 48, paddingHorizontal: 12, justifyContent: 'center', borderBottomColor: '#BFC0C5', borderBottomWidth: 1 }}>
                  <Text style={{ fontSize: 14, color: '#292D32', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>بایگانی</Text>
                </TouchableRipple>
              </>
            :
              <>
                <TouchableRipple rippleColor="rgba(0, 0, 0, .04)" onPress={callButton} style={{ width: '100%', height: 48, paddingHorizontal: 12, justifyContent: 'center', borderBottomColor: '#BFC0C5', borderBottomWidth: 1 }}>
                  <Text style={{ fontSize: 14, color: '#292D32', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>تماس با مالک</Text>
                </TouchableRipple>
                <TouchableRipple disabled={copyLoading} loading={copyLoading} rippleColor="rgba(0, 0, 0, .04)" onPress={copyThemplateToClipboard} style={{ width: '100%', height: 48, paddingHorizontal: 12, justifyContent: 'center', borderBottomColor: '#BFC0C5', borderBottomWidth: 1 }}>
                  <Text style={{ fontSize: 14, color: '#292D32', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>کپی قالب</Text>
                </TouchableRipple>
                <TouchableRipple rippleColor="rgba(0, 0, 0, .04)" onPress={() => router.push(`relatedCustomer/${data._id}`)} style={{ width: '100%', height: 48, paddingHorizontal: 12, justifyContent: 'center', borderBottomColor: '#BFC0C5', borderBottomWidth: 1 }}>
                  <Text style={{ fontSize: 14, color: 'red', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>مشتری‌های پیشنهادی</Text>
                </TouchableRipple>
                {
                  (myContext.role === 'super-admin' && data.class === 'waiting-confirm') ?
                    <TouchableRipple rippleColor="rgba(0, 0, 0, .04)" onPress={confirmAd} style={{ width: '100%', height: 48, paddingHorizontal: 12, justifyContent: 'center', borderBottomColor: '#BFC0C5', borderBottomWidth: 1 }}>
                      <Text style={{ fontSize: 14, color: 'green', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>تایید آگهی</Text>
                    </TouchableRipple>
                  :
                    <TouchableRipple rippleColor="rgba(0, 0, 0, .04)" onPress={rejectAd} style={{ width: '100%', height: 48, paddingHorizontal: 12, justifyContent: 'center', borderBottomColor: '#BFC0C5', borderBottomWidth: 1 }}>
                      <Text style={{ fontSize: 14, color: 'red', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>رد آگهی</Text>
                    </TouchableRipple>
                }
                {
                  data.trash === 1 ?
                    <TouchableRipple rippleColor="rgba(0, 0, 0, .04)" onPress={deArchiveAd} style={{ width: '100%', height: 48, paddingHorizontal: 12, justifyContent: 'center', borderBottomColor: '#BFC0C5', borderBottomWidth: 1 }}>
                      <Text style={{ fontSize: 14, color: '#292D32', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>بازگردانی به پنل</Text>
                    </TouchableRipple>
                  :
                    <TouchableRipple rippleColor="rgba(0, 0, 0, .04)" onPress={() => {refRBSheet.current?.close(); setArchivingModalVisible(true);}} style={{ width: '100%', height: 48, paddingHorizontal: 12, justifyContent: 'center', borderBottomColor: '#BFC0C5', borderBottomWidth: 1 }}>
                      <Text style={{ fontSize: 14, color: '#292D32', fontFamily: 'IRANSans_Medium', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>بایگانی</Text>
                    </TouchableRipple>
                }
              </>
          }
        </ScrollView>
      </RBSheet>
      <Portal>
        <Modal visible={archivingModalVisible} onDismiss={() => setArchivingModalVisible(false)} contentContainerStyle={{ backgroundColor: 'white', padding: 18, marginHorizontal: 18, borderRadius: 4 }}>
          <Text style={{ fontSize: 12, marginBottom: 4, fontFamily: 'IRANSans_Medium', color: '#5B5E63', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>بایگانی آگهی</Text>
          <Text style={{ fontSize: 11, marginBottom: 16, color: '#8D8F94', direction: 'rtl', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>مشاور گرامی برای مدیریت آگهی‌ها، علت بایگانی را وارد کنید.</Text>
          <TextInput
            label="علت بایگانی آگهی"
            placeholder="علت بایگانی آگهی را بصورت کامل وارد کنید"
            mode="outlined"
            value={archivingText}
            onChangeText={text => setArchivingText(text)}
            activeOutlineColor="#c6c5c4"
            style={{ marginBottom: 12, fontSize: 12 }}
          />
          <View style={{ width: '100%', alignItems: 'flex-end', flexDirection: 'row', justifyContent: 'flex-end' }}>
            <Button labelStyle={{ fontSize: 12, color: '#8D8F94' }} onPress={() => setArchivingModalVisible(false)}>انصراف</Button>
            <Button labelStyle={{ fontSize: 12 }} onPress={() => archiveAd()}>بایگانی</Button>
          </View>
        </Modal>
      </Portal>
    </>
  );
};